import React, { useState } from "react";
import PropTypes from "prop-types";
import ErrorScreen from "core/components/ErrorScreen";
import PlayerPreview from "core/components/PlayerPreview";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import DevicesIcon from "@mui/icons-material/Devices";
import CloseViewSessionDialog from "core/components/CloseViewSessionDialog";
import { useViewer } from "core/components/ViewerProvider";

export default function ContentIsNotAvailableByParallelLimit({ content }) {
  const { t } = useTranslation("core");
  const viewer = useViewer();

  const [open, setOpen] = useState(false);

  const title = t("parallelViewsLimit.title");
  const text = t("parallelViewsLimit.text");

  const onClose = () => {
    setOpen(false);
  };

  return (
    <PlayerPreview preview={content.preview} overlay>
      <ErrorScreen
        icon={DevicesIcon}
        title={title}
        text={text}
        button={
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpen(true)}
          >
            {t("parallelViewsLimit.showSessions")}
          </Button>
        }
      />

      {viewer && (
        <CloseViewSessionDialog
          contentId={content.id}
          open={open}
          onClose={onClose}
        />
      )}
    </PlayerPreview>
  );
}

ContentIsNotAvailableByParallelLimit.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    preview: PropTypes.string,
  }).isRequired,
};
